import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Button from "../../../components/UI/Button/Button";
import Spinner from "../../../components/UI/Spinner/Spinner";
import Textarea from "../../../components/UI/Textarea/Textarea";
import { logFirebaseEvent } from "../../../shared/utility";
import * as feedbackActions from "../../../store/actions/index.js";
import classes from "./Feedback.module.css";
import Toast from "react-bootstrap/Toast";

interface IParentProps {
  modalClosed: () => void;
  provider: { providerId: string; providerName: string; postalCode: string };
}
interface IStateFromProps {
  feedbackSubmitted: boolean;
  error: string;
  loading: false;
  t: any;
  logEvent: string;
}
interface IDispatchFromProps {
  onSubmitFeedback: (feedbackData: {
    userId: string;
    providerId: string;
    providerName: string;
    postalCode: string;
    feedback: string;
  }) => void;
}
type Props = IParentProps &
  IStateFromProps &
  IDispatchFromProps &
  RouteComponentProps;

class feedBack extends Component<Props> {
  state = {
    feedback: "",
    errorFeedback: "",
  };

  validateForm = () => {
    let formIsValid = true;
    const { t } = this.props;
    if (!this.state.feedback.trim()) {
      formIsValid = false;
      this.setState({
        errorFeedback: t("errorMsg.errorFeedback"),
      });
    }
    return formIsValid;
  };

  submitHandler = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      logFirebaseEvent(this.props.logEvent);
      const feedback = this.state.feedback.trim();
      const formData = {
        userId: localStorage.getItem("userId")!,
        providerId: this.props.provider.providerId,
        providerName: this.props.provider.providerName,
        postalCode: this.props.provider.postalCode,
        feedback,
      };
      this.props.onSubmitFeedback(formData);
      this.props.modalClosed();
    }
  };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errorFeedback: "",
    });
  };

  render() {
    const { t } = this.props;
    const { modalClosed } = { ...this.props };
    const btnStyle = {
      marginTop: "3px",
      width: "150px",
    };
    let spinner: any;

    if (this.props.loading) {
      spinner = <Spinner />;
    }
    return (
      <Fragment>
        {spinner}
        <div>
          <div className="popupHeader popupHeaderBdr">
            <h6>{t("feedBack.submitFeedBack")}</h6>
            <div className={classes.closeBtn} onClick={modalClosed}>
              X
            </div>
          </div>
          <div className={classes.popupBody}>
            <Textarea
              label={t("feedBack.yourMsg")}
              supportLabel=""
              placeholder=""
              elementLabelStyle={{}}
              elementInputStyle={{}}
              name="feedback"
              errorText={this.state.errorFeedback}
              value={this.state.feedback}
              onChange={(e) => this.handleChange(e)}
            />
            <div className="text-center">
              <Button
                label={t("feedBack.confirm")}
                clicked={this.submitHandler}
                style={btnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  error: state.submitFeedback.error,
  feedbackSubmitted: state.submitFeedback.feedbackSubmitted,
  loading: state.submitFeedback.loading,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onSubmitFeedback: (feedbackData) =>
    dispatch(feedbackActions.submitFeedback(feedbackData)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(feedBack));
